import React from 'react';
import { Container, Typography, Box, Button, Paper, Grid } from '@mui/material';



const styles = {
    container: {
      py: 6,
      fontFamily: "Poppins, sans-serif",
      mt:10
    },
    mainTitle: {
      fontSize: { xs: "2rem", md: "2.5rem" },
      fontWeight: 600,
      color: "#2D3748",
      mb: 2,    
      fontFamily: "Poppins, sans-serif",
    },
    subtitle: {
      fontSize: { xs: "1.5rem", md: "2rem" },
      fontWeight: 600,
      color: "#2D3748",
      mb: 4,
      mt: 8,
      fontFamily: "Poppins, sans-serif",
    },
    sectionTitle: {
      fontSize: { xs: "1.25rem", md: "1.5rem" },
      fontWeight: 600,
      color: "#2D3748",
      mb: 3,
      fontFamily: "Poppins, sans-serif",
    },
    body: {
      fontSize: "1rem",
      color: "#4A5568",
      mb: 4,
      lineHeight: 1.7,
      fontFamily: "Poppins, sans-serif",
    },
    card: {
      p: 4,
      height:"200px",
      borderRadius: 2,
      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
      transition: "transform 0.2s ease-in-out",
      "&:hover": {
        transform: "translateY(-4px)",
      },
    },
    cardTitle: {
      fontSize: "1.25rem",
      fontWeight: 600,
      color: "#2D3748",
      mb: 2,
      fontFamily: "Poppins, sans-serif",
    },
    benefitsList: {
      display: "grid",
      gap: 3,
      mt: 4,
      pl: 0,
      listStyle: "none",
    },
    benefitItem: {
      display: "flex",
      alignItems: "flex-start",
      gap: 2,
      marginBottom:10
    },
    benefitNumber: {
      minWidth: 28,
      height: 28,
      borderRadius: "50%",
      bgcolor: "#4299E1",
      color: "white",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "0.875rem",
    
      fontWeight: 600,
      fontFamily: "Poppins, sans-serif",
    },
    benefitText: {
      fontSize: "15px",
      color: "#4A5568",
      fontFamily: "Poppins, sans-serif",
      ml:1,
    
    },
    ctaButton: {
      mt: 4,
      px: 6,
      py: 1.5,
      borderRadius: 2,
      fontSize: "1rem",
      textTransform: "none",
      fontFamily: "Poppins, sans-serif",
      boxShadow: "0 4px 14px rgba(66, 153, 225, 0.3)",
      "&:hover": {
        boxShadow: "0 6px 20px rgba(66, 153, 225, 0.4)",
      },
    },
  }


function AwareContent() {

    const benefits = [
        "Reduced Stress and Anxiety: Regular meditation can help calm the mind and reduce stress hormones.",
        "Improved Focus and Concentration: By training the mind to stay focused, meditation can enhance cognitive function.",
        "Increased Self-Awareness: Meditation can help us gain a deeper understanding of our thoughts, emotions, and behaviors.",
       
      ]
  return (
    <Container maxWidth="lg" sx={styles.container}>
      <Typography variant="h1" sx={styles.mainTitle}>
        Types of Awareness
      </Typography>
      <Typography sx={styles.body}>
        While we are constantly aware, our attention can fluctuate between different levels of focus:
      </Typography>

      <Grid container spacing={4} sx={{ mb: 8 }}>
        <Grid item xs={12} md={6} sx={{mb:4}}>
          <Paper sx={styles.card}>
            <Typography sx={styles.cardTitle}>Active Awareness</Typography>
            <Typography sx={styles.body}>
              This is focused attention, where we consciously direct our awareness towards a specific object or thought.
              For example, when you're reading this article, you're actively engaged with the text.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper sx={styles.card}>
            <Typography sx={styles.cardTitle}>Passive Awareness</Typography>
            <Typography sx={styles.body}>
              This is a more relaxed form of awareness, where we're passively perceiving our surroundings without active
              focus. You might be passively aware of the background noise or the feeling of the chair beneath you.
            </Typography>
          </Paper>
        </Grid>
      </Grid>

      <Typography variant="h2" sx={styles.subtitle}>
        Meditation and Awareness
      </Typography>
      <Typography sx={styles.body}>
        Meditation, an ancient practice, is a powerful tool for cultivating deeper awareness. By training the mind to
        focus on the present moment, we can become more mindful of our thoughts, feelings, and sensations. This can lead
        to a profound transformation of our consciousness.
      </Typography>

      <Typography variant="h3" sx={styles.sectionTitle}>
        Benefits of Meditation:
      </Typography>

      <ul style={{ padding: 0 ,width:"90%"}} sx={styles.benefitsList}>
        {benefits.map((benefit, index) => (
          <li key={index} style={styles.benefitItem}>
            <Box sx={styles.benefitNumber}>{index + 1}</Box>
            <Typography sx={styles.benefitText}>{benefit}</Typography>
          </li>
        ))}
      </ul>

      <Box sx={{ mt: 8, textAlign: "center" }}>
        <Typography variant="h2" sx={styles.subtitle}>
          Embark on Your Journey of Self-Discovery
        </Typography>
        <Typography sx={{ ...styles.body, maxWidth: 800, mx: "auto" }}>
          To delve deeper into the practice of meditation and unlock the full potential of your awareness, consider
          joining our exclusive personal meditation classes. Our experienced instructors will guide you through tailored
          techniques that resonate with your unique needs and aspirations.
        </Typography>
       <Button
                 variant="contained"
                 size="large"
                 sx={{
                   textTransform:"none",
                   backgroundColor: "#2E3B55",
                   fontFamily: "Poppins, sans-serif",
                   "&:hover": { backgroundColor: "#1A2637" },
               
                 }}
               >
           Join Our Meditation Classes
               </Button>
      </Box>
    </Container>
  );
}

export default AwareContent;